// extracted by mini-css-extract-plugin
export default {"selectorMaxWidth":"_QEd3Q8eliO2eA_p2JQQ"};